import { motion } from "framer-motion";

/**
 * Editorial page banner — large WOW hero used across inner pages.
 * Reusable, with optional eyebrow, kicker, gradient overlay and image.
 */
export default function PageBanner({
  eyebrow,
  title,
  italicWord,
  kicker,
  image,
  height = "h-[60vh] lg:h-[72vh]",
  align = "left",
  testId,
  dark = true,
  children,
}) {
  return (
    <section
      data-testid={testId || "page-banner"}
      className={`relative ${height} overflow-hidden`}
    >
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover img-luxe" />
          <div className={`absolute inset-0 ${dark ? "hero-overlay-strong" : "hero-overlay"}`} />
        </>
      )}

      <div className={`relative h-full max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 flex flex-col justify-end pb-12 lg:pb-20 ${align === "center" ? "items-center text-center" : ""}`}>
        {eyebrow && (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-[11px] tracking-[0.3em] uppercase font-semibold text-[var(--gold-light)]"
          >
            <span className="inline-block w-8 h-px bg-[var(--gold-light)] align-middle mr-3" />
            {eyebrow}
          </motion.div>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 22 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className={`font-serif-display mt-5 text-5xl md:text-6xl lg:text-7xl xl:text-8xl text-white max-w-5xl`}
        >
          {title}
          {italicWord && (
            <>
              <br className="hidden md:block" />
              <span className="font-serif-italic text-[var(--gold-light)]">{italicWord}</span>
            </>
          )}
        </motion.h1>
        {kicker && (
          <motion.p
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="mt-6 text-white/85 text-lg lg:text-xl leading-relaxed max-w-2xl"
          >
            {kicker}
          </motion.p>
        )}
        {children && (
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="mt-8"
          >
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
}
